import { createCore } from '@inter-ikea-core/core';
import { createCoreInstanceStore } from '@inter-ikea-storageone/shared/platform/storeFactories/createCoreInstanceStore';

export const coreInstanceStore = createCoreInstanceStore(createCore());

export const getCoreInstance = () => coreInstanceStore.getState().coreInstance;

export const setCoreInstance = coreInstanceStore.getState().actions.setCoreInstance;
